import ResourceApi from '../ResourceApi';

const SurveyResource = {
  getQuestions: async (params = {}) => (await ResourceApi.get('/resource/survey/questions', params)).data,
  submitResponse: async (params = {}) => (await ResourceApi.post('/resource/survey/respond', params)).data,
  getResults: async (params = {}) => (await ResourceApi.get('/resource/survey/results', params)).data,
};

export default SurveyResource;
